
const {
  REACT_APP_COGNITO_REGION,
  REACT_APP_COGNITO_USER_POOL_ID,
  REACT_APP_COGNITO_USER_POOL_CLIENT_ID,
  REACT_APP_COGNITO_IDENTITY_POOL_ID,
  REACT_APP_COGNITO_IDP_PROVIDER,
  REACT_APP_COGNITO_IDP_DOMAIN,
  REACT_APP_COGNITO_IDP_SCOPES,
  REACT_APP_COGNITO_IDP_REDIRECT_URL,
  REACT_APP_COGNITO_IDP_RESPONSE_TYPE
} = process.env;


const outhConfigBuilder = () => {
  return {
    identity_providers: [REACT_APP_COGNITO_IDP_PROVIDER],
    domain: REACT_APP_COGNITO_IDP_DOMAIN,
    scopes: REACT_APP_COGNITO_IDP_SCOPES ? REACT_APP_COGNITO_IDP_SCOPES.split(',') : [],
    redirect_sign_in_uri: [REACT_APP_COGNITO_IDP_REDIRECT_URL],
    redirect_sign_out_uri: [REACT_APP_COGNITO_IDP_REDIRECT_URL],
    response_type: REACT_APP_COGNITO_IDP_RESPONSE_TYPE
  }
}

export const AmplifyConfig = {
  auth: {
    user_pool_id: REACT_APP_COGNITO_USER_POOL_ID,
    aws_region: REACT_APP_COGNITO_REGION,
    user_pool_client_id: REACT_APP_COGNITO_USER_POOL_CLIENT_ID,
    identity_pool_id: REACT_APP_COGNITO_IDENTITY_POOL_ID,
    mfa_methods: [],
    standard_required_attributes: [
      "email",
      "given_name",
      "family_name"
    ],
    username_attributes: [
      "email"
    ],
    user_verification_types: [
      "email"
    ],
    mfa_configuration: "NONE",
    password_policy: {
      min_length: 8,
      require_lowercase: true,
      require_numbers: true,
      require_symbols: true,
      require_uppercase: true
    },
    unauthenticated_identities_enabled: true,
    oauth: outhConfigBuilder()
  },

  version: "1.3"
};
